import {
  IStrapiFooterNavigation,
  IStrapiLegalNavigation,
  IStrapiSocialNavigation,
  IStrapiGlobalText
} from './strapi-dto';

export const FALLBACK_FOOTER_NAVIGATION: IStrapiFooterNavigation = {
  id: 0,
  createdAt: '',
  updatedAt: '',
  publishedAt: '',
  documentId: '',
  menus: [
    {
      id: 1,
      label: 'Get Started',
      dropdown: true,
      link: null,
      buttons: [
        { id: 1, label: 'Therapy', link: 'https://www.sondermind.com/therapy/' },
        { id: 2, label: 'Psychiatry', link: 'https://www.sondermind.com/psychiatry/' },
        { id: 3, label: 'For Anxiety', link: 'https://www.sondermind.com/therapy-for-anxiety/' },
        { id: 4, label: 'For Depression', link: 'https://www.sondermind.com/depression-therapy/' },
        { id: 5, label: 'For Couples', link: 'https://www.sondermind.com/therapy-for-couples/' },
        { id: 6, label: 'For Veterans', link: 'https://www.sondermind.com/therapy-for-veterans/' },
        { id: 7, label: 'Browse Directory', link: 'https://www.sondermind.com/provider-directory/' },
        { id: 8, label: 'Client Log In', link: 'https://client.sondermind.com/' }
      ]
    },
    {
      id: 2,
      label: 'Resources',
      dropdown: true,
      link: null,
      buttons: [
        {
          id: 9,
          label: 'How SonderMind Works',
          link: 'https://www.sondermind.com/how-sondermind-works/'
        },
        {
          id: 10,
          label: 'Articles and Content',
          link: 'https://www.sondermind.com/resources/articles-and-content/'
        },
        {
          id: 11,
          label: 'Real Results',
          link: 'https://www.sondermind.com/real-results/'
        },
        {
          id: 12,
          label: 'Research and Insights',
          link: 'https://www.sondermind.com/research/'
        },
        {
          id: 13,
          label: 'Using Your Insurance',
          link: 'https://www.sondermind.com/insurance/'
        }
      ]
    },
    {
      id: 3,
      label: 'For Providers',
      dropdown: true,
      link: null,
      buttons: [
        { id: 14, label: 'Join SonderMind', link: 'https://www.sondermind.com/join-sondermind/' },
        {
          id: 15,
          label: 'Refer a Patient',
          link: 'https://www.sondermind.com/refer-a-patient/'
        },
        {
          id: 16,
          label: 'Refer a Provider',
          link: 'https://www.sondermind.com/provider-referrals/'
        },
        {
          id: 17,
          label: 'Clinical Resources',
          link: 'https://www.sondermind.com/resources/clinical-resources/'
        },
        {
          id: 18,
          label: 'Provider Community',
          link: 'https://community.sondermind.com/'
        },
        { id: 19, label: 'Provider Log In', link: 'https://portal.sondermind.com/login/' }
      ]
    },
    {
      id: 5,
      label: 'Company',
      dropdown: false,
      link: null,
      buttons: [
        { id: 25, label: 'About Us', link: 'https://www.sondermind.com/about-us/' },
        { id: 26, label: 'Careers', link: 'https://www.sondermind.com/careers/' },
        { id: 27, label: 'Contact Us', link: 'https://www.sondermind.com/contact-us/' },
        { id: 28, label: 'FAQs', link: 'https://www.sondermind.com/faqs/' },
        { id: 29, label: 'Security', link: 'https://www.sondermind.com/security/' },
        { id: 30, label: 'AI & Policy', link: 'https://www.sondermind.com/ai/' },
        { id: 31, label: 'Press', link: 'https://www.sondermind.com/press/' },
        { id: 32, label: 'Partners', link: 'https://www.sondermind.com/partners/' }
      ]
    }
  ]
};

export const FALLBACK_LEGAL_NAVIGATION: IStrapiLegalNavigation = {
  id: 0,
  createdAt: '',
  updatedAt: '',
  publishedAt: '',
  documentId: '',
  buttons: [
    { id: 1, label: 'Privacy Policy', link: '/privacy-policy' },
    { id: 2, label: 'Terms of Service', link: '/terms-of-service' },
    { id: 3, label: 'Financial Responsibility', link: '/financial-responsibility-agreement' },
    { id: 4, label: 'Notice of Privacy Practices', link: '/notice-of-privacy-practices' }
  ]
};

export const FALLBACK_SOCIAL_NAVIGATION: IStrapiSocialNavigation = {
  id: 0,
  createdAt: '',
  updatedAt: '',
  publishedAt: '',
  documentId: '',
  buttons: [
    { id: 1, link: 'https://www.linkedin.com/company/sondermind/', icon: 'linkedin' },
    { id: 2, link: 'https://www.facebook.com/SonderMind/', icon: 'facebook' },
    { id: 3, link: 'https://www.instagram.com/sondermind/', icon: 'instagram' },
    { id: 4, link: 'https://www.youtube.com/channel/UCSKDPvHeP-30S21iPnQ9Oxw', icon: 'youtube' }
  ]
};

// eslint-disable-next-line max-len
const EMERGENCY_CAPTION = '<h4>In Case of Emergency</h4><p>If you are experiencing a life-threatening emergency, please call 911. If you are experiencing a mental health emergency, please call 988 for the Suicide and Crisis Lifeline. Or, use <a href="/emergency-resources">these resources</a> to get immediate help.</p>';

export const FALLBACK_GLOBAL_TEXT: IStrapiGlobalText = {
  id: 0,
  copyright: '© 2023 SonderMind Inc.',
  footerCaption: EMERGENCY_CAPTION,
  findATherapistUri: 'https://start.sondermind.com/',
  findAPsychiatristUri: 'https://start.sondermind.com/?slug=psychiatry-flow',
  createdAt: '',
  updatedAt: '',
  publishedAt: '',
  documentId: ''
};
